import React from "react";
import Footer from "./Footer";
import logo from "../../assets/images/bet-logo.svg"
import MrFirst from "../MrFirst";
import "./index.scss"
import Translation from "../Translation";

const RegistartionBody = ({children}) => (
        <div className="registration-body">
            <div className="languages">
                <Translation />
            </div>
            <img src={logo} className="auth-logo" alt="betconstruct-logo" />
            <MrFirst/>
            {children}
           <Footer />
        </div>
    )
;

export default RegistartionBody;